import { render, staticRenderFns } from "./ConfirmMdokSubmit.vue?vue&type=template&id=74fe73d1&"
import script from "./ConfirmMdokSubmit.vue?vue&type=script&lang=js&"
export * from "./ConfirmMdokSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports